module.exports = __webpack_public_path__ + "static/media/timer.9a051d64.png";